import { ProgramsBox, IBLSpinLoader, CredentialSearchbar } from '../../../components';
import './ProgramsViewContent.css';
import { NoItemView } from '../../../components/NoItemView';
import React, { useEffect, useState } from 'react';
import { isAdmin, useContentSuggestions, useProfilePrograms } from '../../../hooks';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../../hooks/useDebounce';

export const ProgramsViewContent = ({ username, userId }) => {
  const { profilePrograms, profileProgramsLoaded } = useProfilePrograms(
    username,
    userId
  );
  const {
    content, contentLoaded
  } = useContentSuggestions('program')
  const { t } = useTranslation('library');
  const PROGRAM_TAB = "program"
  const ASSIGNMENT_TAB = "assignment"
  const [currentTab, setCurrentTab] = useState(PROGRAM_TAB)
  const [assignmentPrograms, setAssignmentPrograms] = useState<any[]>([])
  const [programSearchTerm, setProgramSearchTerm] = useState<string>('')
  const [assignedProgramSearchTerm, setAssignedProgramSearchTerm] = useState<string>('')
  const [filteredPrograms, setFilteredPrograms] = useState<any[]>([])
  const [filteredAssignedPrograms, setFilteredAssignedPrograms] = useState<any[]>([])

  useDebounce(()=>{
    if(contentLoaded && content){
      const _assignedPrograms = content?.results?.map((program)=>({
        ...program,
        program_id:program?.program_name,
        name:program?.program_name
      })) ?? []
      setAssignmentPrograms(_assignedPrograms)
      setFilteredAssignedPrograms(_assignedPrograms)
    }
  }, 200, [contentLoaded, content])

  useDebounce(() => {
    if(profileProgramsLoaded && profilePrograms.length > 0){
      setFilteredPrograms(profilePrograms)
    }
  }, 200, [profileProgramsLoaded, profilePrograms]);

  useDebounce(()=>{
    if(programSearchTerm.length > 2){
      setFilteredPrograms(profilePrograms.filter((program) =>String(program?.name).toUpperCase().includes(String(programSearchTerm).toUpperCase())))
    }else{
      setFilteredPrograms(profilePrograms)
    }
  }, 200, [programSearchTerm])

  useDebounce(()=>{
    if(assignedProgramSearchTerm.length > 1){
      setFilteredAssignedPrograms(assignmentPrograms.filter((program) =>String(program?.name).toUpperCase().includes(String(assignedProgramSearchTerm).toUpperCase())))
    }else{
      setFilteredAssignedPrograms(assignmentPrograms)
    }
  }, 200, [assignedProgramSearchTerm])

  return (
    <span>
      <div className="ov_panel active with-custom-tab" data-name="programs">
        <div className="br_cont" style={{padding:'0px'}}>
          <div className="div-block-421" style={{marginBottom:"20px"}}>
              <div className="profile_menu">
                <div onClick={() => setCurrentTab(PROGRAM_TAB)} className={`prof_menu first ${currentTab === PROGRAM_TAB ? "active" : ""}`}>
                  {t('My programs')}
                </div>
                <div onClick={() => setCurrentTab(ASSIGNMENT_TAB)} className={`prof_menu first ${currentTab === ASSIGNMENT_TAB ? "active" : ""}`}>
                  {t('Assigned programs')}
                </div>
              </div>
            </div>
          {
            currentTab===PROGRAM_TAB ? (
              <>
                {
                  profileProgramsLoaded ? (
                    <div className="br_row">
                        <CredentialSearchbar
                          searchTerm={programSearchTerm}
                          setSearchTerm={setProgramSearchTerm}
                          title={t('Programs')}
                          recordCount={Array.isArray(filteredPrograms) ? filteredPrograms.length : 0}
                        ></CredentialSearchbar>
                      <div className="div-block-430 sl program_grid">
                        <ProgramsBox
                          showProgressBar={true}
                          profilePrograms={filteredPrograms}
                          profileProgramsLoaded={profileProgramsLoaded}
                          includeProfilePath={true}
                        />
                      </div>
                    </div>
                  ) : (
                    <IBLSpinLoader size={40} containerHeight={'200px'} />
                  )
                }
                {
                  profileProgramsLoaded &&
                  (!profilePrograms || profilePrograms.length === 0) &&
                  inIframe() && (
                    <NoItemView
                      displayMessage={
                        !inIframe()
                          ? t("You haven't enrolled in any programs yet.")
                          : t(`${username} doesn't have any enrolled programs yet.`)
                      }
                      displayPadding={true}
                    />
                  )
                }
              </>
            ) : (
              <>
                {
                  contentLoaded ? (
                    <div className="br_row">
                        <CredentialSearchbar
                          searchTerm={assignedProgramSearchTerm}
                          setSearchTerm={setAssignedProgramSearchTerm}
                          title={t('Assigned Programs')}
                          recordCount={Array.isArray(filteredAssignedPrograms) ? filteredAssignedPrograms.length : 0}
                        ></CredentialSearchbar>
                      <div className="div-block-430 sl program_grid">
                        <ProgramsBox
                          includeProfilePath={true}
                          showProgressBar={true}
                          isAssignedProgram={true}
                          profilePrograms={filteredAssignedPrograms}
                          profileProgramsLoaded={contentLoaded}
                        />
                      </div>
                    </div>
                  ) : (
                    <IBLSpinLoader size={40} containerHeight={'200px'} />
                  )
                }
                {
                  contentLoaded &&
                  (!assignmentPrograms || assignmentPrograms.length === 0) &&
                   (
                    <NoItemView
                      displayMessage={
                        !inIframe()
                          ? t("You haven't been assigned to any programs yet.")
                          : t(`${username} hasn't been assigned to a programs yet.`)
                      }
                      displayPadding={true}
                    />
                  )
                }
              </>
            )
          }
          {}
          {}
        </div>
      </div>
    </span>
  );
};
